var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2198",
    "data-name": "Grupo 2198",
    transform: "translate(-25.188 -225.188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_890",
    "data-name": "Ret\\xE2ngulo 890",
    width: 60,
    height: 60,
    rx: 10,
    transform: "translate(25.188 225.188)",
    fill: "#d3ff9a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1737",
    "data-name": "Grupo 1737",
    transform: "translate(40.458 238.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1586",
    "data-name": "Grupo 1586",
    transform: "translate(10.152 1.978)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1584",
    "data-name": "Grupo 1584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303",
    "data-name": "Caminho 303",
    d: "M888.841,380.163a1.291,1.291,0,0,1-1.29-1.29V375.69a1.29,1.29,0,0,1,2.581,0v3.183A1.291,1.291,0,0,1,888.841,380.163Z",
    transform: "translate(-887.551 -374.4)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1585",
    "data-name": "Grupo 1585",
    transform: "translate(5.161 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    "data-name": "Caminho 304",
    d: "M891.841,380.12a1.291,1.291,0,0,1-1.29-1.29V375.75a1.29,1.29,0,1,1,2.581,0v3.079A1.291,1.291,0,0,1,891.841,380.12Z",
    transform: "translate(-890.551 -374.46)",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1587",
    "data-name": "Grupo 1587",
    transform: "translate(3.44 17.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    "data-name": "Caminho 305",
    d: "M903.348,385.831H884.94a1.29,1.29,0,1,1,0-2.581h18.408a1.29,1.29,0,0,1,0,2.581Z",
    transform: "translate(-883.65 -383.25)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1588",
    "data-name": "Grupo 1588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    "data-name": "Caminho 306",
    d: "M904.789,393.034a1.291,1.291,0,0,1-.914-2.2L906.4,388.3l-.549-.551a1.285,1.285,0,0,1-.378-.912v-1.118a9.892,9.892,0,0,0-19.784,0v1.118a1.285,1.285,0,0,1-.378.912l-.549.551,2.529,2.527a1.291,1.291,0,0,1-1.825,1.827l-3.441-3.442a1.289,1.289,0,0,1,0-1.824l1.084-1.086v-.583a12.473,12.473,0,1,1,24.945,0v.583l1.084,1.086a1.289,1.289,0,0,1,0,1.824l-3.441,3.442A1.292,1.292,0,0,1,904.789,393.034Z",
    transform: "translate(-881.65 -373.25)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1589",
    "data-name": "Grupo 1589",
    transform: "translate(23.827 12.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M896.79,385.905a1.29,1.29,0,0,1-.912-2.2l.549-.55-.549-.551a1.29,1.29,0,0,1,1.824-1.824l1.462,1.462a1.289,1.289,0,0,1,0,1.824l-1.462,1.462A1.281,1.281,0,0,1,896.79,385.905Z",
    transform: "translate(-895.5 -380.4)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1590",
    "data-name": "Grupo 1590",
    transform: "translate(0 12.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M884.4,385.905a1.28,1.28,0,0,1-.912-.379l-1.462-1.462a1.289,1.289,0,0,1,0-1.824l1.462-1.462a1.29,1.29,0,1,1,1.824,1.824l-.549.551.549.55a1.29,1.29,0,0,1-.912,2.2Z",
    transform: "translate(-881.65 -380.4)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1591",
    "data-name": "Grupo 1591",
    transform: "translate(2.476 22.365)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    "data-name": "Caminho 309",
    d: "M894.548,397.432a11.547,11.547,0,0,1-11.441-9.682,1.29,1.29,0,0,1,2.546-.42,9.02,9.02,0,0,0,17.789,0,1.29,1.29,0,0,1,2.546.42A11.547,11.547,0,0,1,894.548,397.432Z",
    transform: "translate(-883.09 -386.25)",
    fill: "#d3ff9a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0a6cd402f9f81891c14904ffd6c3dade.svg";
export { ForwardRef as ReactComponent };